var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _g, _rect, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhyPentugramImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 590,
    height: 370,
    viewBox: "0 0 590 370",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M111.952 94.3435C111.952 94.3435 112.382 158.226 187.658 152.76",
    stroke: "#3070CC",
    strokeWidth: 0.987956,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M111.936 32.3572H111.904C102.088 32.3572 94.1366 40.0697 94.1366 49.5668C94.1366 52.5307 94.8855 55.3193 96.2559 57.7573L98.3434 61.008C99.9847 63.5575 101.052 66.3939 101.514 69.3578L102.343 74.7756H121.513L122.58 68.7682C123.042 66.1868 123.966 63.7009 125.337 61.4382L127.568 57.7413C128.922 55.3193 129.687 52.5466 129.703 49.5827C129.703 40.1175 121.736 32.3572 111.968 32.3413L111.936 32.3572Z",
    fill: "#25B06D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M118.182 50.0764H105.626L108.86 77.1655H114.947L118.182 50.0764Z",
    stroke: "white",
    strokeWidth: 0.987956,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M111.904 74.7913H102.327V83.412H111.904H121.576V74.7913H111.904Z",
    fill: "#3070CC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M111.952 25.9673V16.3108",
    stroke: "#3070CC",
    strokeWidth: 0.987956,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M88.655 49.2639H78.9985",
    stroke: "#3070CC",
    strokeWidth: 0.987956,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4751 65.7405L88.655 72.5765",
    stroke: "#3070CC",
    strokeWidth: 0.987956,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4751 32.7874L88.655 25.9673",
    stroke: "#3070CC",
    strokeWidth: 0.987956,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M144.905 49.2639H135.248",
    stroke: "#3070CC",
    strokeWidth: 0.987956,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M135.248 25.9673L128.428 32.7874",
    stroke: "#3070CC",
    strokeWidth: 0.987956,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M135.248 72.5765L128.428 65.7405",
    stroke: "#3070CC",
    strokeWidth: 0.987956,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M270.954 45.9681L268.047 41.0166L252.128 50.3576L255.035 55.3091L245.921 71.3599L240.18 71.3958L240.323 89.8505L246.064 89.8146L255.405 105.722L252.571 110.721L268.622 119.823L271.444 114.836L289.899 114.704L292.805 119.656L308.725 110.303L305.818 105.363L314.932 89.3123L320.661 89.2645L320.529 70.8217L314.788 70.8575L305.447 54.9384L308.282 49.9509L292.231 40.8372L289.397 45.8366L270.954 45.9681Z",
    fill: "white",
    stroke: "#3070CC",
    strokeWidth: 0.741539,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M280.319 65.571C288.476 65.5112 295.126 72.0774 295.185 80.2223C295.245 88.3793 288.679 95.0292 280.534 95.089C272.377 95.1488 265.727 88.5826 265.667 80.4376C265.608 72.2927 272.174 65.6308 280.319 65.571Z",
    fill: "white",
    stroke: "#3070CC",
    strokeWidth: 0.741539,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M398.29 41.8331C401.041 24.7334 389.409 8.64111 372.31 5.88993C355.21 3.13875 339.118 14.7705 336.366 31.8703C333.615 48.97 345.247 65.0623 362.347 67.8135C379.446 70.5647 395.539 58.9329 398.29 41.8331Z",
    fill: "white",
    stroke: "#3070CC",
    strokeWidth: 0.741539,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M358.432 34.199H351.519V53.2039H358.432V34.199Z",
    fill: "#F5F8FD",
    stroke: "#F5F8FD",
    strokeWidth: 0.191365,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M369.459 29.5464H362.546V53.2158H369.459V29.5464Z",
    fill: "#F5F8FD",
    stroke: "#F5F8FD",
    strokeWidth: 0.191365,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M382.532 19.7749H375.619V53.2159H382.532V19.7749Z",
    fill: "#3070CC"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M347.249 53.2039H387.447",
    stroke: "#3070CC",
    strokeWidth: 0.741539,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M414.585 129.379C414.585 129.379 437.609 87.8651 396.489 64.7219",
    stroke: "#3070CC",
    strokeWidth: 0.741539,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M254.126 43.9228L252.834 34.0077L249.748 34.4143L243.672 26.4727L244.868 23.6022L235.635 19.7629L234.451 22.6334L224.536 23.9251L222.646 21.4613L214.704 27.5371L216.594 30.0129L212.755 39.2463L209.669 39.6529L210.961 49.568L214.047 49.1734L220.122 57.103L218.926 59.9735L228.16 63.8128L229.356 60.9423L239.271 59.6506L241.161 62.1264L249.09 56.0505L247.201 53.5867L251.04 44.3533L254.126 43.9467V43.9228ZM232.932 49.7116C228.555 50.2857 224.536 47.1999 223.962 42.8224C223.388 38.445 226.473 34.4263 230.863 33.8522C235.24 33.2781 239.259 36.3639 239.833 40.7533C240.407 45.1308 237.321 49.1494 232.932 49.7116Z",
    fill: "#3070CC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_156_4072)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M197.481 353.654H487.396C495.758 353.654 502.545 346.867 502.545 338.51V134.59H182.343V338.51C182.343 346.867 189.134 353.654 197.481 353.654Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.406 90.8376H197.491C189.124 90.8376 182.343 97.6246 182.343 105.982V134.709H502.54V105.982C502.54 97.6246 495.748 90.8376 487.401 90.8376H487.406Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.331 113.241C213.331 117.911 209.545 121.712 204.879 121.712C200.214 121.712 196.423 117.911 196.423 113.241C196.423 108.57 200.204 104.784 204.879 104.784C209.555 104.784 213.331 108.56 213.331 113.241Z",
    fill: "#F5F8FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.015 113.241C237.015 117.911 233.22 121.712 228.539 121.712C223.859 121.712 220.093 117.911 220.093 113.241C220.093 108.57 223.879 104.784 228.539 104.784C233.2 104.784 237.015 108.56 237.015 113.241Z",
    fill: "#F5F8FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.68 113.241C260.68 117.911 256.899 121.712 252.229 121.712C247.559 121.712 243.782 117.911 243.782 113.241C243.782 108.57 247.554 104.784 252.229 104.784C256.904 104.784 260.68 108.56 260.68 113.241Z",
    fill: "#F5F8FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.863 105.624H291.947C287.746 105.624 284.34 109.029 284.34 113.23C284.34 117.432 287.746 120.837 291.947 120.837H472.863C477.065 120.837 480.47 117.432 480.47 113.23C480.47 109.029 477.065 105.624 472.863 105.624Z",
    fill: "#F5F8FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.132 158.076H199.538V164.366H269.132V158.076Z",
    fill: "#F5F8FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.014 158.076H434.805V164.366H479.014V158.076Z",
    fill: "#F5F8FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.229 158.076H379.009V164.366H423.229V158.076Z",
    fill: "#F5F8FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.443 158.076H323.223V164.366H367.443V158.076Z",
    fill: "#F5F8FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.728 188.165H199.538V248.904H254.728V188.165Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.498 188.165H274.304V248.904H329.498V188.165Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.249 188.165H349.059V248.904H404.249V188.165Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.019 188.165H423.83V248.904H479.019V188.165Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.728 265.936H199.538V326.706H254.728V265.936Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.498 265.936H274.304V326.706H329.498V265.936Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.249 265.936H349.059V326.706H404.249V265.936Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.019 265.936H423.83V326.706H479.019V265.936Z",
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 182.843,
    y: 91.3376,
    width: 319.198,
    height: 261.817,
    rx: 11.5,
    stroke: "black",
    strokeOpacity: 0.07
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_156_4072)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M589.299 317.007H0.670776V317.623H589.299V317.007Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.299 268.858H0.670776V269.474H589.299V268.858Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.299 220.708H0.670776V221.324H589.299V220.708Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.299 172.554H0.670776V173.17H589.299V172.554Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.34149 369.091L0 365.812L117.718 317.658L235.411 266.14L353.501 218.428H472.307L588.634 171.356L589.96 174.641L472.998 221.965H354.187L236.782 269.404L119.099 320.917L1.34149 369.091Z",
    fill: "#F8F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.096 319.213L235.446 318.95L118.389 271.078L1.34149 318.95L0 315.675L118.389 267.253L119.059 267.526L236.141 315.412L352.771 271.113L470.474 126.243L588.594 74.9385L590 78.1829L472.675 129.139L354.917 274.089L354.47 274.253L236.096 319.213Z",
    fill: "#25B06D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.572 122.73C468.829 122.73 466.598 124.956 466.598 127.694C466.598 130.431 468.829 132.667 471.572 132.667C474.314 132.667 476.54 130.436 476.54 127.694C476.54 124.951 474.314 122.73 471.572 122.73Z",
    fill: "#25B06D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.586 272.599C360.586 276.315 357.565 279.336 353.844 279.336C350.123 279.336 347.107 276.315 347.107 272.599C347.107 268.882 350.123 265.857 353.844 265.857C357.565 265.857 360.586 268.882 360.586 272.599Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.844 281.11C349.154 281.11 345.338 277.294 345.338 272.604C345.338 267.914 349.154 264.093 353.844 264.093C358.534 264.093 362.355 267.914 362.355 272.604C362.355 277.294 358.534 281.11 353.844 281.11ZM353.844 267.63C351.106 267.63 348.881 269.861 348.881 272.604C348.881 275.346 351.106 277.572 353.844 277.572C356.582 277.572 358.812 275.346 358.812 272.604C358.812 269.861 356.582 267.63 353.844 267.63Z",
    fill: "#25B06D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.116 312.346C233.374 312.346 231.143 314.572 231.143 317.315C231.143 320.057 233.374 322.288 236.116 322.288C238.859 322.288 241.08 320.057 241.08 317.315C241.08 314.572 238.854 312.346 236.116 312.346Z",
    fill: "#25B06D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.389 264.192C115.651 264.192 113.43 266.423 113.43 269.166C113.43 271.908 115.656 274.139 118.389 274.139C121.121 274.139 123.362 271.908 123.362 269.166C123.362 266.423 121.131 264.192 118.389 264.192Z",
    fill: "#25B06D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.873 220.783C357.873 224.499 354.858 227.52 351.131 227.52C347.405 227.52 344.389 224.499 344.389 220.783C344.389 217.067 347.41 214.041 351.131 214.041C354.853 214.041 357.873 217.057 357.873 220.783Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.136 229.294C346.446 229.294 342.625 225.478 342.625 220.788C342.625 216.098 346.446 212.277 351.136 212.277C355.826 212.277 359.647 216.098 359.647 220.788C359.647 225.478 355.826 229.294 351.136 229.294ZM351.136 215.814C348.394 215.814 346.168 218.045 346.168 220.783C346.168 223.52 348.399 225.751 351.136 225.751C353.874 225.751 356.105 223.525 356.105 220.783C356.105 218.04 353.874 215.814 351.136 215.814Z",
    fill: "#25B06D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.214 220.783C478.214 224.499 475.199 227.52 471.477 227.52C467.756 227.52 464.74 224.499 464.74 220.783C464.74 217.066 467.761 214.041 471.477 214.041C475.194 214.041 478.214 217.056 478.214 220.783Z",
    fill: "#25B06D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.785 147.478H118.746V334.202H259.785V147.478Z",
    fill: "white",
    stroke: "#3070CC",
    strokeWidth: 0.987956,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.623 258.114C240.614 240.123 240.614 210.955 222.623 192.965C204.633 174.974 175.464 174.974 157.474 192.965C139.483 210.955 139.483 240.123 157.474 258.114C175.464 276.104 204.633 276.104 222.623 258.114Z",
    fill: "#F8F8F9",
    stroke: "#F8F8F9",
    strokeWidth: 0.254956,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.054 225.543L155.253 186.279C161.834 180.431 169.929 176.225 178.836 174.281L190.054 225.543Z",
    fill: "#3070CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.304 287.784H223.788",
    stroke: "#3070CC",
    strokeWidth: 0.987956,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.304 299.48H223.788",
    stroke: "#3070CC",
    strokeWidth: 0.987956,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.304 311.176H223.788",
    stroke: "#3070CC",
    strokeWidth: 0.987956,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.632 251.915L190.054 225.543L180.621 276.295",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_156_4072"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 182.343,
    y: 90.8376,
    width: 320.198,
    height: 262.817,
    rx: 12,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_156_4072"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 590,
    height: 294.153,
    fill: "white",
    transform: "translate(0 74.9385)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyPentugramImage);
export default __webpack_public_path__ + "static/media/why-pentugram-image.83283ed360c57c0594ae9817ad82f277.svg";
export { ForwardRef as ReactComponent };